/* unplugin-vue-components disabled */import script from "./LoginRegister.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginRegister.vue?vue&type=script&lang=ts&setup=true"

import "./LoginRegister.vue?vue&type=style&index=0&id=134c7c33&lang=scss&scoped=true"
import "./LoginRegister.vue?vue&type=style&index=1&id=134c7c33&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134c7c33"]])

export default __exports__